module.exports = __webpack_public_path__ + "xlsx-00f1128bf702cff4154773ffb27d3181.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/file-formats/xlsx.svg
// module id = 48
// module chunks = 0